import { Link } from 'react-router-dom'
import { BackLink } from 'src/components/common'
import { useResource } from 'src/hooks/useResource'

import { routes } from 'src/navigation/routes'

export const TeacherPracticeOptions = () => {
  const { resourceType, resourceName } = useResource()

  const { favorites = 0 } = {}

  return (
    <>
      <div className="sectionHb-top">
        <BackLink to={`/lessons/${resourceType}`} />
        <h2 className="sectionHb-title">New {resourceName}s: Options</h2>
      </div>

      <div className="sectionHb-block worksheetsHb">
        <div className="sectionHb-block__wrap">
          <div className="options-row">
            <div className="options-col">
              <Link to={routes[resourceType].new_auto} className="options-wrap">
                <div className="options-ico">
                  <img src="/account/img/options/options-1.svg" alt="" />
                </div>
                <span className="options-title">Auto generated</span>
              </Link>
            </div>
            <div className="options-col">
              <Link to={routes[resourceType].new} className="options-wrap">
                <div className="options-ico">
                  <img src="/account/img/options/options-3.svg" alt="" />
                </div>
                <span className="options-title">Prepare manualy</span>
              </Link>
            </div>
            <div className="options-col" />
            <div className="options-col">
              <Link
                to={routes.library.index}
                className="options-wrap options-blue"
              >
                <div className="options-ico">
                  <img src="/account/img/options/options-4.svg" alt="" />
                </div>
                <span className="options-title">Practice library</span>
              </Link>
            </div>
            <div className="options-col">
              <Link
                to={routes.favorites.index}
                className="options-wrap options-blue"
              >
                <span className="options-circle">{favorites}</span>
                <div className="options-ico">
                  <img src="/account/img/options/options-5.svg" alt="" />
                </div>
                <span className="options-title">Favorites</span>
              </Link>
            </div>
            <div className="options-col">
              <Link
                to={routes.marketplace.index}
                className="options-wrap options-blue"
              >
                <div className="options-ico">
                  <img src="/account/img/options/options-6.svg" alt="" />
                </div>
                <span className="options-title">Search marketplace</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
